import { stringToEnum } from '@snap-types/util/enum';

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  DISABLED = 'DISABLED',
}

export const userStatusSchema = stringToEnum(UserStatus);
